// src/hooks/useApiErrorHandler.ts
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toaster } from '@/components/ui/toaster';
import { logToMonitoringService } from '@/services/monitoringService';
import { isApiError } from '@/utils/isApiError'; // Assuming you have this
// import type { ApiError } from '@/types/api';
// import { routeTo } from '@/router/routeTo';

export function useApiErrorHandler() {
  // const navigate = useNavigate();
  const { t } = useTranslation(['errors']);

  const handleError = (
    error: unknown,
    setFormErrors?: (errors: { [key: string]: string }) => void
  ) => {

    // 1. Ensure it's a structured API error
    if (!isApiError(error)) {
      console.error("An unexpected error occurred:", error);
      toaster.error({ title: t('errors:unexpectedError.title') });
      return;
    }

    const apiError = error.response.data;
    logToMonitoringService(apiError);

    // 2. Handle specific, known error codes
    switch (apiError.errorCode) {
      case 'SESSION_EXPIRED':
      case 'INVALID_TOKEN':
        toaster.error({
          title: t('errors:sessionExpired.title'),
          description: t('errors:sessionExpired.description'),
          closable: false,
          duration: 10000,
        });
        // navigate(routeTo.signIn());
        return; // Stop further processing

      case 'INSUFFICIENT_PERMISSIONS':
        toaster.error({
          title: t('errors:insufficientPermissions.title'),
          description: t('errors:insufficientPermissions.description'),
          closable: false,
          duration: 10000,
        });
        // navigate(routeTo.dashboard());
        return;

      case 'VALIDATION_FAILED':
        if (setFormErrors && apiError.details) {
          const translatedErrors: Record<string, string> = {};

          for (const field in apiError.details) {
            const { key, params } = apiError.details[field];
            // Use i18next to translate the key and interpolate the params
            translatedErrors[field] = t(key, params);
          }

          setFormErrors(translatedErrors);
          // Display a general message as well
          toaster.warning({
            title: t('errors:validationFailed.title'),
            closable: false,
            duration: 10000,
          });
          return;
        }

        // For all other errors, show a generic message from the API
        toaster.error({ title: apiError.message, duration: 10000, closable: false });
    };
  }

  return { handleError };
}